export default {
	name: 'Convention.Registration.Store.Category',
	path: 'convention/registration/store/:id',
	parent: 'Convention.Registration.Store',
	topLevel: true,
	collection: true,
	meta: {
		auth: true
	}
}